import { Routes } from '@angular/router';
import {
  ExecutionOfTrafficOrganizationProjectsComponent
} from './execution-of-traffic-organization-projects/execution-of-traffic-organization-projects.component';
import { AuthGuard } from '../../../guards/auth.guard';
import { IsCompletedUserDataGuard } from '../../../guards/is-completed-user-data.guard';

export const createExternalApplicationsRoutes: Routes = [
  {
    component: ExecutionOfTrafficOrganizationProjectsComponent,
    path: 'e-uslugi/wykonanie-projektow-organizacji-ruchu',
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  }
];

export const editExternalApplicationsRoutes: Routes = [
  {
    component: ExecutionOfTrafficOrganizationProjectsComponent,
    path: 'wnioski-robocze/wykonanie-projektow-organizacji-ruchu/:appId',
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  }
];
